import React, {useState} from "react";
import {addInfluencer} from "../../apihelper/addToPortfolio";
import {useNavigate} from "react-router-dom";
import {Alert, Snackbar} from "@mui/material";

const AddCreatorForm = () => {
    const [creatorName, setCreatorName] = useState("");
    const [description, setDescription] = useState("");
    const [youtubeLink, setYoutubeLink] = useState("");
    const [xLink, setXLink] = useState("");
    const [telegramLink, setTelegramLink] = useState("");
    const [instagramLink, setInstagramLink] = useState("");
    const [creatorImage, setCreatorImage] = useState("");
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [alertMessage, setAlertMessage] = useState("");
    const [snackbaropen, setSnackbaropen] = useState(false);
    const [severity, setSeverity] = useState("info");
    const navigate = useNavigate();

    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbaropen(false);
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await addInfluencer(
                creatorName,
                description,
                creatorImage,
                youtubeLink,
                xLink,
                telegramLink,
                instagramLink,
                userData.user_id
            );
            console.log(response);
            setAlertMessage(response.message);
            setSnackbaropen(true);
            setSeverity(response.error ? "error" : "success");
        } catch (error) {
            setAlertMessage(error.message || "Something went wrong");
            setSeverity("error"); // Set severity to error on failure
            setSnackbaropen(true);
        }
    };

    return (
        <>
            {" "}
            <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                <div className="main-section">
                    <div className="heading">
                        <img
                            src={window.constants.asset_path + "/images/backarrow.svg"}
                            alt=""
                            onClick={() => navigate('/create-portfolio')}
                        />
                        <span>Creator</span>
                    </div>

                    <div className="creator-form">
                        <div>
                            <p className="creator-label">
                                Enter Creator Name <span className="required-field">*</span>
                            </p>
                            <input
                                type="text"
                                value={creatorName}
                                onChange={(e) => setCreatorName(e.target.value)}
                                required
                                className="creator-input"
                            />
                        </div>

                        <div>
                            <p className="creator-label">
                                Description <span className="required-field">*</span>
                            </p>
                            <textarea
                                required
                                className="creator-input"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            ></textarea>
                        </div>
                        <div>
                            <label className="creator-label" htmlFor="creator-image">
                                Upload Image <span className="required-field">*</span>
                            </label>
                            <input
                                id="creator-image"
                                type="file"
                                accept="image/jpeg, image/png"
                                required
                                onChange={(e) => setCreatorImage(e.target.files[0])}
                                className="creator-input"
                            />
                            <small className="smaller-text" style={{color: "#6b7280"}}>
                                Upload JPG or PNG file only
                            </small>
                        </div>

                        <div>
                            <div className="d-flex">
                                <img
                                    src={"/images/icons/social_icons/youtube-icon.svg"}
                                    alt="youtube-icon"
                                    width={25}
                                    className="link-icon"
                                />
                                <p className="creator-label">Youtube Link</p>
                            </div>
                            <input
                                type="text"
                                value={youtubeLink || ""}
                                onChange={(e) => setYoutubeLink(e.target.value)}
                                className="creator-input"
                            />
                        </div>
                        <div>
                            <div className="d-flex">
                                <img
                                    src={"/images/icons/social_icons/twitter_icon.svg"}
                                    alt="twitter-icon"
                                    width={20}
                                    className="link-icon"
                                />
                                <p className="creator-label">X Link</p>
                            </div>

                            <input
                                type="text"
                                value={xLink || ""}
                                onChange={(e) => setXLink(e.target.value)}
                                className="creator-input"
                                
                            />
                        </div>
                        <div>
                            <div className="d-flex">
                                <img
                                    src={"/images/icons/social_icons/telegram_icon.svg"}
                                    alt="telegram-icon"
                                    width={20}
                                    className="link-icon"
                                />
                                <p className="creator-label">Telegram Link</p>
                            </div>

                            <input
                                type="text"
                                value={telegramLink || ""}
                                onChange={(e) => setTelegramLink(e.target.value)}
                                className="creator-input"
                            />
                        </div>
                        <div>
                            <div className="d-flex">
                                <img
                                    src={"/images/icons/social_icons/instagram_icon.svg"}
                                    alt="instagram-icon"
                                    width={25}
                                    className="link-icon"
                                />
                                <p className="creator-label">Instagram Link</p>
                            </div>

                            <input
                                type="text"
                                value={instagramLink || ""}
                                onChange={(e) => setInstagramLink(e.target.value)}
                                className="creator-input"
                            />
                        </div>
                        <div className="d-flex justify-content-center">
                            <button className="submit-button shadow">Submit Creator</button>
                        </div>
                    </div>
                </div>
            </form>
            <Snackbar
                open={snackbaropen}
                autoHideDuration={5000}
                onClose={closesnackbar}
                anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            >
                <Alert severity={severity}>{alertMessage}</Alert>
            </Snackbar>
        </>
    );
};

export default AddCreatorForm;
